import React from 'react';
import { BellIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { noticeText } from '../data/bankData';
export function SpecialNotice() {
  return <div className="relative w-full h-full overflow-hidden flex items-stretch" style={{
    background: 'linear-gradient(90deg, #003F7D 0%, #001a33 50%, #003F7D 100%)',
    borderTop: '2px solid rgba(127,181,57,0.6)',
    borderBottom: '2px solid rgba(127,181,57,0.6)'
  }} data-id="element-110">
      {/* Label block — solid brand green */}
      <div className="flex items-center gap-3 px-6 shrink-0" style={{
      background: 'linear-gradient(90deg, #7FB539, #5e9229)'
    }} data-id="element-111">
        <motion.div animate={{
        rotate: [0, -15, 15, -10, 10, 0]
      }} transition={{
        duration: 1.4,
        repeat: Infinity,
        repeatDelay: 2
      }} className="flex items-center justify-center h-10 w-10 rounded-lg bg-white/20 border border-white/30" data-id="element-112">
          <BellIcon className="h-5 w-5 text-white" data-id="element-113" />
        </motion.div>
        <span className="tracking-display text-lg font-extrabold text-white uppercase tracking-[0.18em]" data-id="element-114">
          Special Notice
        </span>
      </div>

      {/* Marquee */}
      <div className="relative flex-1 flex items-center overflow-hidden" data-id="element-115">
        <div className="flex animate-marquee whitespace-nowrap" data-id="element-116">
          <span className="tracking-display text-xl font-semibold text-white pr-24" data-id="element-117">
            {noticeText}
          </span>
          <span className="tracking-display text-xl font-semibold text-white pr-24" data-id="element-118">
            {noticeText}
          </span>
        </div>
        {/* edge fades into the dark navy */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-[#001a33] to-transparent" data-id="element-119" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-[#003F7D] to-transparent" data-id="element-120" />
      </div>
    </div>;
}